import type { FinTechStack } from '@shared/types'
import { FinTechStackSchema } from '@shared/fin/schemas'

interface Props {
  value: FinTechStack | undefined
  onChange: (value: FinTechStack | undefined) => void
  id?: string
}

export default function FinancePlatformSelect({ value, onChange, id }: Props) {
  return (
    <select
      id={id}
      value={value || ''}
      onChange={(e) => onChange((e.target.value as FinTechStack) || undefined)}
      className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-300 bg-white"
    >
      <option value="">None / Not specified</option>
      {FinTechStackSchema.options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  )
}
